import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  loginStatus: boolean = false;
  showList = false;
  atDashboard: boolean = false;
  facilityName: string;
  welcomeLogin: boolean;
  showAvatarDropdown: boolean = false;
  adminLogin = sessionStorage.getItem("adminLogin") == 'true' ? true : false;
  menuItems = [
    { type: 'FACILITY',roleId:'2', name:'Login as Facility'},
    { type: 'ASSESSOR',roleId:'3', name:'Login as Assessor' },
    { type: 'ADMIN',roleId:'1',name:'Login as Admin/CSE' },
  ];
  constructor(private router: Router) {
    this.loginStatus = sessionStorage.getItem("loginStatus") == 'true' ? true : false;
    console.log(router.url);

    if (router.url == '/dashboard' || router.url == '/') {
      this.atDashboard = true;
    }

    if (router.url == '/welcome-login') {
      this.welcomeLogin = true;
    }

    this.facilityName = sessionStorage.getItem("facility name")

  }

  ngOnInit(): void {
  }

  navigateToLogin(item) {
    const roleName=item.name;
    const roleId=item.roleId;
    sessionStorage.setItem('item',JSON.stringify(item))

  // Encode roleName and roleId using btoa before passing them as query parameters
  const encodedRoleName = btoa(roleName);
  const encodedRoleId = btoa(roleId);

  // Use the navigate method to redirect to the login component and pass parameters
  this.router.navigate(['/login'], {
    queryParams: { roleName: encodedRoleName, roleId: encodedRoleId }
  });
  }

  redirectToDashboard() {
    this.router.navigate(['/'])
  }

  redirectToHome() {
    if (this.adminLogin) {
      this.router.navigate(['/admin/dashboard'])
    } else {
      this.router.navigate(['/welcome-login'])
    }
  }

  redirectToDetailRegister() {
    let is_profile_updated = sessionStorage.getItem("is_profile_updated");

    // if (this.router.url == '/login/detailed-register') {
    //   this.router.navigate(['/login/detailed-register']);
    // } else if (this.router.url == '/welcome-login') {
    //   let params = `isDisable=true&is_profile_updated=${is_profile_updated}`
    //   this.router.navigateByUrl(`login/detailed-register?${params}`);
    // }

    console.log('this.router.url',this.router.url);
    
    let params = btoa(`isDisable=true&is_profile_updated=${is_profile_updated}`);
    this.router.navigateByUrl(`login/detailed-register?${params}`)
  }

  // let params = `isDisable=true&is_profile_updated=${this.is_profile_updated}`
  // this.router.navigateByUrl(`login/detailed-register?${params}`)

  getStartedClick() {
    this.router.navigateByUrl('login/register');
  }

  logoutClick() {
    sessionStorage.clear();
    this.router.navigateByUrl('dashboard');
    Swal.fire("Success", 'Logged out successfully', 'success').then(()=>{
      window.location.reload();
    });
  }
  toggleList() {
    this.showList = !this.showList;
  }
  
}
